
<template>
	<page>
		<module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage" @load="refreshSelectedDebt">
            <template #search>
					<m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
						<m-search-item label="订单号">
							<c-input name="keyword" placeholder="销售单号"></c-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="产品名称/背贴码/IMEI"></c-input>
						</m-search-item>
						<m-search-item label="客户">
                            <c-select name="customer_id" async @search="searchCustomer"></c-select>
                        </m-search-item>
                        <m-search-item label="关联还款单">
                            <c-input name="record_no" placeholder=""></c-input>
                        </m-search-item>
                        <m-search-item label="售卖类型">
                            <c-select name="sell_type" :options="sellTypeOptions"></c-select>
                        </m-search-item>
                        <m-search-item label="下单时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_credit_bill_repayment')" color="main" prepend-icon="tf-batch" @click="createRepaymentOrder()">生成还款单</c-button>
					<!--列表导出（与列表同DAO同条件口径）-->
					<c-button v-if="auth('b_credit_bill_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <!--已选订单欠款汇总（随勾选实时统计，口径=勾选行当前欠款合计）-->
                    <div class="selected-debt-tip" v-show="selectedDebtAmount> 0">
                        <span class="label">已选订单欠款：</span>
                        <span class="value">{{formatPrice(selectedDebtAmount)}}</span>
                    </div>
				</template>

                <template #product_info="{data}">
                    <m-product-info :name="data.product_name || getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                </template>

				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<template #produce_code="{data}">
					{{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #sale_price="{data}">
					<span style="color: green;">{{formatPrice(data.sale_price)}}</span>
				</template>

				<template #after_sale_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
				</template>

				<!--退款中金额：已申请售后但尚未完成退款，存在退款中的订单不允许生成还款单-->
				<template #refunding_amount="{data}">
					<span style="color: #dd6b20;">{{Number(data.refunding_amount || 0) > 0 ? formatPrice(data.refunding_amount) : '-'}}</span>
				</template>

				<template #debt_amount="{data}">
					<span style="color:brown;" v-if="data.credit_bill_state != 3">{{formatPrice(data.debt_amount)}}</span>
					<span v-else>-</span>
				</template>
                <!--账单状态-->
				<template #credit_bill_state="{data}">
                    <c-state async dict="CREDIT_BILL_STATE" tag :value="data.credit_bill_state"></c-state>
                </template>

				<template #receiver_info="{data}">
					<div class="m-product-info">
						<p v-if="data.receiver_name">{{data.receiver_name}}　{{data.receiver_phone}}</p>
						<p v-if="data.receiver_address" class="m-product-info-code">{{data.receiver_address}}</p>
						<p v-if="!data.receiver_name && !data.receiver_address">-</p>
					</div>
				</template>

				<template #sell_type="{data}">
                    <!--拆机行悬停动态查询拆机项详情（与线下订单列表同口径）-->
                    <c-tooltip v-if="data.sell_type == 2" position="bottom" color="white" @mouseenter.native="loadDismantleItems(data)">
                        <span class="sell-type-dismantle">
                            <c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
                            <i class="tf tf-detail"></i>
                        </span>
                        <template #tip>
                            <p v-if="getDismantleState(data).loading" class="m-dismantle-item">正在查询拆机项...</p>
                            <p v-else-if="getDismantleState(data).error" class="m-dismantle-item">{{getDismantleState(data).error}}</p>
                            <template v-else>
                                <p v-for="(item, index) in getDismantleState(data).items" :key="index" class="m-dismantle-item">{{item}}</p>
                                <p v-if="!getDismantleState(data).items.length" class="m-dismantle-item">暂无拆机项</p>
                            </template>
                        </template>
                    </c-tooltip>
					<c-state v-else async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
				</template>

				<template #create_user_id="{data}">
					{{data.create_user_realname || '-'}}
				</template>
                <!--关联还款单-->
                <template #repayment_order="{data}">
                    <c-link v-if="auth('b_credit_repayment_view') && data.repayment_order" color="blue" @click="creditRepaymentDetail(data)">
                        {{data.repayment_order}}
                    </c-link>
                    <span v-else-if="data.repayment_order">{{data.repayment_order}}</span>
                    <span v-else>{{data.repayment_order}}</span>
                </template>

                <!--还款审批记录（含驳回后与账单解绑的历史还款单）-->
                <c-table-column
                        v-if="auth('b_credit_repayment_view')"
                        type="button"
                        label="操作"
                        width="90"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-record" @click="viewRepaymentLog(data)">审批记录</c-table-button>
                    </template>
                </c-table-column>
			</view-list>

            <!--生成还款单弹窗-->
            <c-dialog ref="dialog" title="生成还款单" width="500" @resolve="handleCreateRepaymentOrder">
                <c-form ref="form" unit-width="100%">
                    <c-form-item label="还款订单数">
                        <c-input name="order_count" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="还款总金额">
                        <c-input name="repayment_amount" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="备注">
                        <c-input type="textarea" name="remark" maxlength="500" placeholder="请输入信息信息"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
    import {asyncMapState} from '@/store'

    export default {
		data() {
            return {
                workType: 122,
                orderIds: [],
                repayment_amount:0,
                customer_id:0,
                //已选订单欠款总额（勾选行实时统计）
                selectedDebtAmount: 0,
                //售卖类型筛选项（1：整机，2：拆机）
                sellTypeOptions: [{
                    name: '整机',
                    value: 1
                }, {
                    name: '拆机',
                    value: 2
                }],
                /**售卖类型列悬停拆机项查询状态：key=order_id，每次悬停实时查询不跨次复用 */
                dismantleMap: {}
            }
		},
        computed: {
            // 获取dictName选项数据
            ...mapState(['saasInfo']),
            ...asyncMapState(['SALE_SELL_TYPE', 'DISMANTLE_ITEM'])
        },
        mounted() {
            // 勾选行变动实时统计已选订单欠款（view_list 未对外抛出勾选事件，参照 view_list 包装 c-table 的方式挂钩 selectHandle）
            var view = this.$refs.view;
            if (!view) return;
            var self = this;
            var _selectHandle = view.selectHandle;
            view.selectHandle = function (row) {
                _selectHandle.call(this, row);
                self.refreshSelectedDebt();
            };
        },
		methods: {
			/*********搜索客户**********/
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********统计已勾选订单的欠款总额（已还款行后端欠款为0，口径同当前欠款列）**********/
			refreshSelectedDebt() {
				var listRef = this.$refs.view && this.$refs.view.$refs.list;
				var rows = (listRef && listRef.getRow('selected') || []).map(item => item.data || item);
				this.selectedDebtAmount = rows.reduce((acc, item) => {
					return acc + Number(item.debt_amount || 0);
				}, 0);
			},

			/*********悬停售卖类型列：实时查询该订单商品的拆机项**********/
			loadDismantleItems(data) {
				if (data.sell_type != 2) return;
				var key = data.order_id;
				var state = this.dismantleMap[key];
				// 在途请求未返回前不重复发起，避免鼠标移动抖动产生并发查询
				if (state && state.loading) return;
				this.$set(this.dismantleMap, key, {
					loading: true,
					error: '',
					products: []
				});
				this.request({
					url: '/offline/sale/order/dismantleItems',
					data: {
						order_no: data.order_no
					},
					fail: (code, obj, msg) => {
						// 悬停查询失败不弹全局提示，错误信息在浮层内展示
						this.$set(this.dismantleMap, key, {
							loading: false,
							error: msg || '拆机项查询失败',
							products: []
						});
						return false;
					},
					success: result => {
						this.$set(this.dismantleMap, key, {
							loading: false,
							error: '',
							products: (result && result.products) || []
						});
					}
				});
			},

			/*********获取当前行拆机项浮层状态（查询中/失败/拆机项名称列表）**********/
			getDismantleState(data) {
				var state = this.dismantleMap[data.order_id] || {};
				var items = [];
				if (!state.loading && !state.error) {
					// 接口按订单号返回全部商品，取当前行商品（列表行 id 即订单商品ID）的拆机项
					var product = (state.products || []).find(item => item.id == data.id);
					items = this.formatDismantleItems(product ? product.dismantle_items : '');
				}
				return {
					loading: !!state.loading,
					error: state.error || '',
					items: items
				};
			},

			/*********解析拆机项并按字典翻译显示名称（存储为字典value数组，与开单页口径一致）**********/
			formatDismantleItems(value) {
				if (!value) return [];
				var list = value;
				if (typeof list == 'string') {
					try {
						list = JSON.parse(list);
					} catch (e) {
						return [value];
					}
				}
				if (!Array.isArray(list)) return [];
				var dict = this.DISMANTLE_ITEM || [];
				return list.map(item => {
					// 数组项为字典value或{value,name}对象，统一取value后翻译为字典名称展示
					var val = String(item && item.value ? item.value : item);
					var option = dict.find(dic => String(dic.value) == val);
					return option ? option.name : val;
				}).filter(item => item);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

            //检验参数
            validateCustomer(list) {
                // 取第一个作为基准值
                this.customer_id = list[0].customer_id;
                const validList = list;
                if (validList.length <= 1) {
                    return true;
                }
                // 只要有任意一个和基准不一样，校验失败
                const hasDiff = validList.some(item => {
                    return item.customer_id !== this.customer_id;
                });

                if (hasDiff) {
                    return false;
                }
                return true;
            },

			/*********生成还款单（单个/批量）**********/
			createRepaymentOrder(selectedRows) {
                this.orderIds = [];
                this.repayment_amount = 0;
                this.customer_id = 0;
				var rows = [];
				if (selectedRows && selectedRows.order_id) {
					// 单个订单收款
					rows = [selectedRows];
				} else {
					// 批量收款：获取选中的行（参照线上订单批量生成发货单写法）
					rows = (selectedRows || []).map(item => item.data || item);
					if (!rows.length) {
						var listRef = this.$refs.view && this.$refs.view.$refs.list;
						rows = (listRef && listRef.getRow('selected') || []).map(item => item.data || item);
					}
				}

				if (!rows.length) {
					this.$message({message: '请先选择订单', type: 'warn'});
					return;
				}

				// 仅待付款订单可收款
				rows = rows.filter(item => item.credit_bill_state == 1);
				if (!rows.length) {
					this.$message({message: '请选择“待还款”状态的订单进行操作', type: 'warn'});
					return;
				}
				// 存在退款中（已申请售后未完成退款）的订单不允许还款：退款金额尚未最终确定，还款金额会与实际欠款不符
				var refundingOrderNos = [];
				rows.forEach(item => {
					if (Number(item.refunding_amount || 0) > 0 && refundingOrderNos.indexOf(item.order_no) < 0) {
						refundingOrderNos.push(item.order_no);
					}
				});
				if (refundingOrderNos.length) {
					this.$message({
						message: '订单【' + refundingOrderNos.join('、') + '】存在退款中的售后退款，请待退款完成后再生成还款单',
						type: 'warn'
					});
					return;
				}
				var zeroOrderNos = [];
				rows.forEach(item => {
					if (Number(item.debt_amount || 0) <= 0 && zeroOrderNos.indexOf(item.order_no) < 0) {
                        zeroOrderNos.push(item.order_no);
					}
				});
				if (zeroOrderNos.length) {
					this.$message({
						message: '订单【' + zeroOrderNos.join('、') + '】已全额退款无需还款，无法生成还款单',
						type: 'warn'
					});
					return;
				}

                if (!this.validateCustomer(rows)){
                    this.$message({
                        message: '只能请选择同一个客户的订单进行还款操作',  // 提示内容,
                        type: 'warn'
                    });
                    return;
                }
				// 还款金额按订单维度汇总（列表为订单商品明细驱动，同一订单多商品只计一次；口径=付款金额-已退款金额，与后端校验一致）
				var amountMap = {}, orderIds = [];
				rows.forEach(item => {
					if (amountMap[item.order_id] !== undefined) return;
					var paid = (item.paid_amount === null || item.paid_amount === undefined || item.paid_amount === '') ? item.sale_price : item.paid_amount;
					amountMap[item.order_id] = Number(paid || 0) - Number(item.after_sale_amount || 0);
					orderIds.push(item.order_id);
				});
				this.orderIds = orderIds;
				this.repayment_amount = Math.round(orderIds.reduce((acc, id) => acc + amountMap[id], 0) * 100) / 100;
                this.$refs.form.set({
                    customer_id:this.customer_id,
                    order_count:this.orderIds.length,
                    repayment_amount: this.formatPrice(this.repayment_amount)
                });
                this.$refs.dialog.open();
			},

            /******提交跟进记录*******/
            handleCreateRepaymentOrder(stop, next) {
                stop();
                this.$refs.form.submit({
                    url: '/order/credit/repayment/create',
                    rule: {},
                    dataFormatter: (data) => {
                        data.order_ids = this.orderIds;
                        data.customer_id = this.customer_id;
                        data.repayment_amount = this.repayment_amount;
                        return data;
                    },
                    success: (data) => {
                        next();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.$refs.view.update();
                        //生成还款单成功后，打开还款单详情弹窗，可直接发起通联付款
                        if (data && data.repayment_id) {
                            this.globalDialog('creditRepaymentDetail', {
                                props: {
                                    id: data.repayment_id
                                }
                            }, this.$refs.view.update);
                        }
                    }
                });
            },
            //打开还款单详情页
            creditRepaymentDetail(data){//打开模板选择弹窗
                this.globalDialog('creditRepaymentDetail', {
                    props: {
                        id: data.repayment_id
                    }
                }, this.$refs.view.update);
            },
            //打开还款审批记录弹窗（该账单历次提交的还款单及审核结果）
            viewRepaymentLog(data){
                this.globalDialog('creditRepaymentLog', {data: data});
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
/* 已选订单欠款汇总提示条 */
.selected-debt-tip {
	display: flex;
	align-items: center;
	height: 30px;
	padding: 0 12px;
	border: 1px solid #FBD5D5;
	border-radius: 4px;
	background: #FEF0F0;
	font-size: 13px;
	color: #E53E3E;

	.value {
		font-weight: bold;
	}
}

/* 拆机售卖类型：标签+详情图标 */
.sell-type-dismantle {
	display: inline-flex;
	align-items: center;
	gap: 2px;

	.tf-detail {
		font-size: 12px;
		color: #ff6900;
		cursor: help;
	}
}

.m-dismantle-item {
	margin: 0;
	line-height: 20px;
}
</style>
